import * as React from 'react';
import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface ToolbarButtonProps {
    onClick: () => void;
    disabled?: boolean;
    children: React.ReactNode;
    tooltip: string;
    active?: boolean;
}

export function ToolbarButton({
    onClick,
    disabled,
    children,
    tooltip,
    active,
}: ToolbarButtonProps) {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    type="button"
                    size="sm"
                    variant="ghost"
                    className={cn(
                        'h-8 w-8 rounded-md p-0 transition-all duration-100',
                        'text-muted-foreground hover:text-foreground hover:bg-accent',
                        active && 'bg-primary/10 text-primary hover:bg-primary/15'
                    )}
                    onClick={onClick}
                    disabled={disabled}
                >
                    {children}
                </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="text-xs">
                {tooltip}
            </TooltipContent>
        </Tooltip>
    );
}

export function ToolbarDivider() {
    return <div className="mx-1 h-5 w-px bg-border/40" />;
}
